import { Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DepositSearchResult } from '../../models/depositSearchResult.model';
import { RemittanceEntry } from '../../models/remittance-entry.model';
import { RemittanceSummary } from '../../models/remittance-summary.model';

@Injectable()
export class RemittanceEntryService implements OnInit {
  //  Observables
  private checkDetailSource = new Subject<DepositSearchResult>()
  private createRemittanceSource = new Subject<RemittanceEntry>()
  private updateRemittanceSource = new Subject<RemittanceEntry>()
  private remittanceSummarySource = new Subject<RemittanceSummary>()

  private remittanceStageEditSource = new Subject<RemittanceEntry>()
  private remittanceStageDeleteSource = new Subject<RemittanceEntry>()

  checkDetailSource$ = this.checkDetailSource.asObservable()
  createRemittanceSource$ = this.createRemittanceSource.asObservable()
  updateRemittanceSource$ = this.updateRemittanceSource.asObservable()

  remittanceSummarySource$ = this.remittanceSummarySource.asObservable()

  remittanceStageEditSource$ = this.remittanceStageEditSource.asObservable()
  remittanceStageDeleteSource$ = this.remittanceStageDeleteSource.asObservable()

  constructor() { }

  ngOnInit(): void {
  }

  notifyCheckDetail(check: DepositSearchResult) {
    this.checkDetailSource.next(check)
  }

  notifyCreateRemittance(remittance: RemittanceEntry) {
    this.createRemittanceSource.next(remittance)
  }

  notifyUpdateRemittance(remittance: RemittanceEntry) {
    this.updateRemittanceSource.next(remittance)
  }

  notifyRemittanceSummary(summary: RemittanceSummary) {
    this.remittanceSummarySource.next(summary)
  }

  notifyRemittanceStageEdit(remittance: RemittanceEntry) {
    this.remittanceStageEditSource.next(remittance)
  }

  notifyRemittanceStageDelete(remittance: RemittanceEntry) {
    this.remittanceStageDeleteSource.next(remittance)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/remittance-entry.service.ts